<section class="breadcrumb-banner">
    <div class="container">
        <div class="row">
            <div class="col-md-12 col-lg-12">
                <div class="breadcrumb-text">
                    <h1>Pune District Badminton Championship 2025 </h1>
                </div>
            </div>
        </div>
    </div>
    <div class="breadcrumb-bottom-img">
        <img src="https://rgicdn.s3.ap-south-1.amazonaws.com/raisoni/rgi/images/identity/white-group-identity.png"  alt="GHRSCF"/>
    </div>
</section>
<section class="section section-sm fide-chesscompetition section-banner-bg-1">
    <div class="container">
        <div class="sec-title text-center">
            <h2><span>G H Raisoni Memorial Pune District Badminton Championship </span></h2>
        </div>
        <div class="row justify-content-between">
            <div class="col-md-12">
                <p><strong>Event Name:</strong> "Raisoni Foundation Presents Yonex-Sunrise G.H. Raisoni Memorial Pune
                    District Badminton Championship 2025"</p>
                <p><strong>Dates:</strong> 1st – 8th June 2025</p>
                <p><strong>Venue:</strong> P.E. Society’s Modern PDMBA Sports Complex, Shivajinagar, Pune </p>
                <p><strong>Referee: </strong>Mr. Vivek Saraf</p>
                <!-- <p><strong>Organised by:  </strong>Dhule City and Taluka Badminton Association & Raisoni Foundation Sports and Cultural  </p> -->
                <h6>Events Categories:</h6>
                <ul class="list-style list-style1 ">
                    <li>Players Participated: 1,235</li>
                    <li>Total Entries: 1,671</li>
                    <li>Total Matches Played: 1,639</li>
                    <li>Number of Events: 49</li>
                    <li>Total Walkovers: 53</li>
                </ul>
                <h6>Highlights:</h6>
                <p>A prestigious Super 1000 event, held under the guidelines of the Maharashtra Badminton Association.
                </p>

                <p>Excellent turnout across all age groups, from U9 to Senior Categories, including Singles, Doubles,
                    and Mixed Doubles.</p>

                <p>Notable champions include Suveer Pradhan (Men’s Singles), Tanishka Deshpande (Women’s Singles), Aadya
                    Parasnis & Krishna Jasuja (Men’s Doubles), and many rising young athletes.</p>

                <p>A total of 3,526 games were played, clocking in over 30,000 minutes of competitive badminton.</p>

                <p>Raisoni Foundation generously contributed ₹2,00,000/- to the Poona District & Metropolitan Badminton
                    Association (PDMBA) to support the successful execution of this major district-level sporting event.
                </p>

                <p>This sponsorship ensures continued promotion of grassroots badminton talent in Pune.</p>
            </div>
            <!-- <div class="col-md-4">
              <div class="image-effect-3">
                  <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/sport/upcoming-sports/dhule-badminton-champioship-25-may.jpg"
                      alt="GHRSCF" />
              </div>
          </div> -->
        </div>
        <div class="lightBox--gallery">
            <ul class="list-unstyled lightgallery row row-cols-1 row-cols-md-4">
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-1.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-1.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-1.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-2.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-2.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-2.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-3.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-3.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-3.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-4.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-4.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-4.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-5.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-5.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-5.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-6.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-6.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-6.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-7.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-7.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-7.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-8.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-8.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-8.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-9.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-9.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-9.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>
                <li class="col"
                    data-responsive="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-10.webp"
                    data-src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-10.webp">
                    <a href="Javascript:void(0);">
                        <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/events/sports-events/badminton-championship-25/badminton-championship-25-10.webp"
                            alt="GHRSCF" title="GHRSCF" class="img-fluid" />
                        <div class="light-gallery-poster">
                            <img src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/images/zoom-icon.png" alt="GHRSCF"/>
                        </div>
                    </a>
                </li>

            </ul>
        </div>
        <div class="mt-5">
            <iframe src="https://ghrscfcdn.s3.ap-south-1.amazonaws.com/ghrscf/pdf/tournament-report-PDC-25-pune.pdf"
                frameborder="0" width="100%" height="550"></iframe>
        </div>
    </div>
</section>
